import { render, staticRenderFns } from "./SurveyResultDetail.vue?vue&type=template&id=79f65d10&scoped=true"
import script from "./SurveyResultDetail.vue?vue&type=script&lang=js"
export * from "./SurveyResultDetail.vue?vue&type=script&lang=js"
import style0 from "./SurveyResultDetail.vue?vue&type=style&index=0&id=79f65d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f65d10",
  null
  
)

export default component.exports